import clsx from 'clsx';
import Link from 'next/link';
import { AnchorHTMLAttributes } from 'react';

import { getButtonClassName } from '@pflegia/ui/shared/button';
import LinkWithLoader from '@pflegia/ui/shared/link-with-loader/LinkWithLoader.component';

interface LearnMoreButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  isLinkLoadingDisabled?: boolean;
  href: string;
  title: string;
}

const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({ className, href, title, isLinkLoadingDisabled = false, ...props }) => {
  const buttonClassName = getButtonClassName('secondary', clsx('flex items-center justify-center no-underline! content-center', className));

  if (isLinkLoadingDisabled)
    return (
      <Link href={href} {...props} className={buttonClassName}>
        {title}
      </Link>
    );

  return (
    // Need to override sm display because of default button styling
    <LinkWithLoader href={href} {...props} className={buttonClassName} spinnerClassName='text-current'>
      {title}
    </LinkWithLoader>
  );
};
export default LearnMoreButton;
